import { render, staticRenderFns } from "./emojiIcon.vue?vue&type=template&id=4ff37046&scoped=true&"
import script from "./emojiIcon.vue?vue&type=script&lang=js&"
export * from "./emojiIcon.vue?vue&type=script&lang=js&"
import style0 from "./emojiIcon.vue?vue&type=style&index=0&id=4ff37046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff37046",
  null
  
)

export default component.exports